import {QuoteService} from 'quote-domain-core';
import {EnumQuoteServiceType} from 'quote-domain-core';
import {AbstractServiceCalculator, PricingModeEnum} from "../abstract-service-calculator";
import { QuoteServiceMergeStrategy } from '../../service/quote-service/quote-service-corridor-pipeline-service';

export class DasriRenewalServiceCalculator extends AbstractServiceCalculator {

    constructor(public quoteService: QuoteService, public referential: any, public referentialServices: any, public mergeQuantity: boolean, public canChangePricingItemPrice: boolean, public pricingMode: PricingModeEnum) {
        super(quoteService, referential, referentialServices, mergeQuantity, canChangePricingItemPrice, pricingMode)
    }

    execute() {
        let referentialService = this.referentialServices.find((referential: any) => referential.serviceCode === EnumQuoteServiceType.DASRI);
        this.corridorPipelineService.execute(this.quoteService, this.referential, {
            mergeStrategy: this.mergeQuantity ? QuoteServiceMergeStrategy.ARTICLE_CODE : QuoteServiceMergeStrategy.BASE_QUANTITY,
            pricingMode: this.pricingMode
        });
        this.lifecycleService.applyGlobalDiscountAndRecalculate(this.quoteService);
        this.commercialService.calculateCollectorPrice(this.quoteService, referentialService, this.referential);
        this.lifecycleService.complete(this.quoteService, { resetDistance: true, updateLastAppliedPriceState: true });
    }

}

